<template>
  <el-header height="102px;line-height:102px">
    <div class="headerBar">
      <div class="searchTab">
        <div class="logo" @click="toHome">
          <!-- <router-link to="/"> -->
          <img :src="logo" alt />
          <!-- </router-link> -->
        </div>
        <div class="so">
          <div class="channel">
            <template v-if="name">
              <div
                v-if="!FIsAgree || (FIsAgree && FShowAllStock)"
                class="shopBtn"
                :class="isShoping ? 'active' : ''"
                @click="shopBtn(true)"
              >
                全部商品
              </div>
              <div
                v-if="FIsAgree"
                class="shopBtn"
                :class="!isShoping ? 'active' : ''"
                @click="shopBtn(false)"
              >
                目录商品
              </div>
            </template>
            <div
              v-else
              class="shopBtn"
              :class="isShoping ? 'active' : ''"
              @click="shopBtn(true)"
            >
              全部商品
            </div>
          </div>
          <div class="searchStockIpt">
            <el-autocomplete
              ref="search"
              v-model="search"
              :popper-class="computName"
              :fetch-suggestions="querySearch"
              :trigger-on-focus="true"
              placeholder="请输入内容"
              :popper-append-to-body="false"
              @keydown.native.enter="searchClick"
              @select="handleSelect"
            >
              <template slot-scope="{ item }">
                <template v-if="typeof item === 'string'">
                  <span
                    class="name"
                    :name="computName"
                    style="margin: auto"
                    v-html="item || ''"
                  />
                </template>
                <template v-else>
                  <p
                    v-if="item.index === 0"
                    :name="computName"
                    class="allHisDel"
                    @click.stop.prevent="deleHistroy(true)"
                  >
                    清除所有记录
                  </p>
                  <span class="name" v-html="item.text || ''" />
                  <span
                    class="delhis"
                    style="font-size: 12px; color: #888"
                    @click.stop.prevent="deleHistroy(item.index)"
                    >删除历史</span
                  >
                </template>
              </template>
              <template>
                <el-button
                  slot="append"
                  class="searchButton"
                  icon="el-icon-search"
                  @click="searchClick"
                  >搜索
                </el-button>
              </template>
            </el-autocomplete>
          </div>
        </div>
        <div class="rightButton">
          <!-- <el-button class="Box" @click="toFastBuy">
                    <svg-icon icon-class="quickly" />
                    快速求购
                  </el-button>
                  <el-button class="Box" @click="shopCart()">
                    <svg-icon icon-class="cart" />
                    购物车
                  </el-button> -->
          <router-link class="headorgBoxTo" to="/shop/shoppingCart">
            <div class="boxto-con">
              <svg-icon icon-class="white-shop" />
              <span class="box-text">我的购物车</span>
              <span
                v-show="comput.FSCQuanty && comput.FSCQuanty != 0"
                class="fizz"
                >{{ comput.FSCQuanty | maxwting }}</span
              >
            </div>
          </router-link>
          <router-link class="headBoxTo" to="">
            <div class="boxto-con">
              <svg-icon icon-class="noload" />
              <span class="box-text">清单导入</span>
            </div>
          </router-link>
        </div>
      </div>
      <div class="navBar">
        <ul class="navigation">
          <li>
            <div
              class="classifyGoods"
              @mouseover="onclassover()"
              @mouseleave="onclassout()"
            >
              <!-- <div class="top" @click="reSearch">
                          <svg-icon icon-class="shangpinfenlei" />
                          全部商品分类
                        </div> -->
              <div v-show="isnavMenuShow" class="nav-menu">
                <ul class="menu-wrap">
                  <li
                    v-for="(item, index) in stockClassList"
                    v-if="item.indexCatalogs&&item.indexCatalogs.firstCatalog.length"
                    :key="index"
                    class="menu-item"
                  >
                    <div class="classBox">
                      <img class="seleimg" :src="item.FImagePath" alt="" />
                      <!-- <div class="goodsName">{{ item.FContent }}</div> -->
                      <div class="goodsName">
                        <template
                          v-for="(item1, index1) in item.indexCatalogs
                            .firstCatalog"
                        >
                          <span
                            :key="index1"
                            class="subSpan"
                            @click="toSearch(item1)"
                            >{{ item1.FStdStockClassName }}</span
                          >
                        </template>
                      </div>
                    </div>
                    <!-- <div v-for="(item1, index1) in item.indexCatalogs.firstCatalog" :key="index1" class="subclass">
                                <span class="subSpan" @click="toSearch(item1)">{{ item1.FStdStockClassName }}</span>
                              </div> -->
                    <div
                      v-if="item.indexCatalogs.childrenCatalog.length"
                      class="children"
                    >
                      <ul>
                        <li
                          v-for="(item2, index) in item.indexCatalogs
                            .childrenCatalog"
                          :key="index"
                        >
                          <div class="shopType" @click="toSearch(item2)">
                            <!-- 配电及控制电器 -->
                            {{ item2.FStdStockClassName }}
                            <!-- <i class="el-icon-arrow-right" /> -->
                          </div>
                          <div class="shopKind">
                            <div
                              v-for="(it, indexs) in item2.children"
                              :key="indexs"
                              @click="toSearch(it)"
                            >
                              {{ it.FStdStockClassName }}
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <!-- <li v-for="(item, index) in plateData" :key="index" class="liTotal" @click="totalClick(item)">
                      <img style="display: inline-block; width: 17px; height: 18px" :src="item.FImagePath" alt="">
                      <div class="blodText">{{ item.FContent }}</div>
                    </li> -->
        </ul>
      </div>
    </div>
  </el-header>
</template>

<script>
import { getIndexShopDecoration, getCatalogSet } from "@/api/home";
import { mapGetters, mapActions } from "vuex";

import quest from "@/views/manageMent/api/user";
import logoimg from "@/assets/images/logoimg.png";
export default {
  filters: {
    maxwting(num) {
      if (isNaN(Number(num))) return "0";
      if (Number(num) > 99) return "99+";
      return num;
    },
  },
  data() {
    return {
      FIsAgree: 0,
      FShowAllStock: 0,
      comput: {},
      searchHref: "",
      searchHistory: false, // 是否显示搜索历史
      HistoryObj: {
        shop: [], // 商品搜索历史
        supplier: [], // 供方搜索历史
      },
      activeIndex: "", // 头部导航栏选中的标签
      search: "", // 搜索条件
      register: false, // 是否显示注册组件
      visible: false, // 是否退出登录
      routerList: [], // 用户中心左侧显示的列表
      showModel: "shopCart", // 显示的区域
      restaurants: [],
      isShoping: true, // 默认选择商品按钮
      isStore: false,
      routerPath: "", // 当前的路由地址
      isnavMenuShow: true, // 商品分类的显示隐藏
      timeout: null,
      stockClassList: [
        "机电产品",
        "工具耗材",
        "化学品",
        "安防清洁",
        "行政办公",
      ],
      footerTwo: [],
      plateData: [],
      logo: "",
      threeData: [],
      strfid: "0",
      routePush: {},
    };
  },
  watch: {},
  computed: {
    ...mapGetters(["getUser", "getNum", "name"]),
    computName() {
      let search = localStorage.getItem("homeSearchHistory");
      const key = this.isShoping ? "shop" : "supplier";
      if (search) {
        search = JSON.parse(search);
        if (search[key].length) {
          return "my-autocomplete all-history";
        } else {
          return "my-autocomplete";
        }
      } else {
        return "my-autocomplete";
      }
    },
  },
  watch: {
    $route: {
      handler(val, olval) {
        if (val.path == "/Home") {
          // 如果是home页面，则让分类展开不消失
          this.routerPath = val;
          this.isnavMenuShow = true;
        } else {
          // 如果不是home页面，则分类消失，移入显示
          this.routerPath = val;
          this.isnavMenuShow = false;
        }
      },
    },
    isShoping() {
      this.resetRecommend();
    },
  },
  mounted() {
    this.restaurants = this.loadAll();
    this.onclassout();
    // 获取首页侧边栏列表数据
    this.getStockClass();
    this.getLogo();
    this.getComput();
    const userInfo = localStorage.getItem("userInfo");
    userInfo &&
      ((this.FIsAgree = JSON.parse(userInfo).FIsAgree),
      (this.FShowAllStock = JSON.parse(userInfo).FShowAllStock));
    if (this.$route.query.isShoping != undefined) {
      const isShoping = Number(this.$route.query.isShoping);
      if (!(this.isShoping == isShoping)) {
        this.isShoping = !!isShoping;
      }
    } else {
      //   console.log(this.FIsAgree, this.FShowAllStock)
      //   if(this.FIsAgree && this.FShowAllStock) {
      //       this.isShoping = false
      //   } else if(){

      //   }
      if (this.FIsAgree) {
        this.isShoping = false;
      } else if (this.FIsAgree && this.FShowAllStock) {
        this.isShoping = false;
      } else if (!this.FIsAgree) {
        this.isShoping = true;
      }
    }
  },
  beforeUpdate() {
    this.activeIndex = this.$route.path;
  },
  created() {
    this.getLogo();
    this.routerList = this.$router.options.routes.filter(
      (item) => item.showHome
    );
  },
  methods: {
    ...mapActions(["setShowLogin", "setShoppingCart"]),
    toHome() {
      const isShoping = this.$route.query.isShoping;
      this.$router.push({
        path: "/Home",
        query: {
          isShoping,
        },
      });
    },
    catalogue() {
      this.isShoping = false;
    },
    resetRecommend() {
      if (this.$route.name == "Home") {
        const home = this.$parent.$parent.$refs.home;
        home.PageNo = 1;
        home.PageSize = 15;
        home.itemRecommend = [];
        home.isMore = true;
        home.dataList.length && (home.activeName = home.dataList[0].FTreeCode);
        home.activeName && home.getRecommend(home.activeName);
      }
    },
    getComput() {
      const userInfo = localStorage.getItem("userInfo");
      if (userInfo) {
        const userInfoj = JSON.parse(userInfo);
        // console.log(userInfoj)
        if (userInfoj.fuserId) {
          quest.fszzInfo(userInfoj.fuserId).then((res) => {
            this.comput = res.data || 0;
          });
        }
      }
    },
    reSearch() {
      this.search = "";
      this.searchClick();
    },
    toSearch(item) {
      const Time = new Date().getTime();
      let isShoping = 0;
      if (location.href.indexOf("?") > -1) {
        try {
          isShoping = new URL(
            "http://127.0.0.1:8081" +
              location.href.slice(location.href.indexOf("?"))
          ).searchParams.get("isShoping");
        } catch (e) {
          console.warn(e);
        }
      }

      console.log(isShoping);
      const routeUrl = this.$router.resolve({
        path: "/search/searchPage",
        redirect: "",
        query: {
          classification: item.FTreeCode,
          Time,
          isShoping,
        },
      });
      window.open(routeUrl.href, "_blank"); // 新标签页打开商品详情
    },
    goSearch(item) {
      //   console.log(item)
    },
    selectStyle(item) {
      if (item.FID == this.strfid) {
        return;
      } else {
        this.strfid = item.FID;
        this.getStockClass();
        getCatalogSet({ fparentID: item.FID }).then((res) => {
          this.threeData = res.rows;
        });
      }
    },
    totalClick(item) {},

    // 首页模块
    getLogo() {
      const id = localStorage.getItem("userInfo")
        ? JSON.parse(localStorage.getItem("userInfo")).funitID
        : "";
      const params = {
        modelID: 1,
        fDemandUnitId: id,
      };
      getIndexShopDecoration(params)
        .then((res) => {
          this.plateData = res.classification;
          this.logo = res.malllogo.length
            ? res.malllogo[0].FImagePath
              ? res.malllogo[0].FImagePath
              : logoimg
            : logoimg;
        })
        .catch(() => {
          this.logo = logoimg;
        });
    },

    login() {
      // 点击登录按钮, 通过更改vuex的showLogin值显示登录组件
      this.setShowLogin(true);
    },
    // 接收注册子组件传过来的数据
    isRegister(val) {
      this.register = val;
    },
    querySearch(queryString, cb) {
      this.searchHistory = !this.searchHistory;
      if (this.search === "" || this.search === undefined) {
        this.searchHistory = true;
        let search = localStorage.getItem("homeSearchHistory");
        const key = this.isShoping ? "shop" : "supplier";
        if (search) {
          search = JSON.parse(search);

          if (search[key].length) {
            const arr = search[key].map((text, index) => {
              return { text, index };
            });
            cb(arr);
          } else {
            cb(["无历史记录"]);
          }
        } else {
          cb(["无历史记录"]);
        }
      } else {
        this.searchHistory = false;
        cb([]);
      }
      // var restaurants = this.restaurants
      // var results = queryString
      //   ? restaurants.filter(this.createFilter(queryString))
      //   : restaurants
      // // 调用 callback 返回建议列表的数据
      // clearTimeout(this.timeout)
      // this.timeout = setTimeout(() => {
      //   cb(results)
      // }, 1000 * Math.random())
    },
    deleHistroy(index) {
      let search = localStorage.getItem("homeSearchHistory");
      search = JSON.parse(search);
      const key = this.isShoping ? "shop" : "supplier";
      if (typeof index === "boolean") {
        search[key] = [];
        this.$refs.search.suggestions = [];

        localStorage.setItem("homeSearchHistory", JSON.stringify(search));
        return;
      } else {
        search[key].splice(index, 1);
        localStorage.setItem("homeSearchHistory", JSON.stringify(search));
      }
      this.$refs.search.suggestions.splice(index, 1);
      this.$refs.search.suggestions = this.$refs.search.suggestions.map(
        (item, index) => {
          item.index = index;
          return item;
        }
      );
    },
    //  切换标签
    shopBtn(val) {
      this.isShoping = val;
      this.isStore = !val;
      const query = {};
      if (typeof this.$route.query === "object") {
        for (const key in this.$route.query) {
          query[key] = this.$route.query[key];
        }
      }
      query.isShoping = Number(this.isShoping);
      this.$router.push({
        path: this.$route.path,
        query,
      });
      //   console.log(this.$parent.$parent.$refs.home)
    },
    // 点击选择供方按钮
    storeBtn() {
      this.isStore = true;
      this.isShoping = false;
    },
    // 点击搜索按钮
    searchClick() {
      const isShoping = Number(
        this.$parent.$parent.$refs.headerSearch.isShoping
      );
      var Time = new Date().getTime();
      let search = localStorage.getItem("homeSearchHistory");
      if (!search) {
        search = { shop: [], supplier: [] };
      } else {
        search = JSON.parse(search);
      }
      if (this.$route.query.markID) {
        this.$router.push({
          path: "/search/searchPage",
          query: {
            search: this.search,
            Time,
            markID: this.$route.query.markID,
            isShoping,
          },
        });
      } else {
        this.$router.push({
          path: "/search/searchPage",
          query: { search: this.search, Time, isShoping },
        });
      }
      if (this.isShoping) {
        if (this.search != "") {
          var searindex = search.shop.indexOf(this.search);
          if (searindex > -1) {
            search.shop.unshift(search.shop.splice(searindex, 1)[0]);
          } else {
            if (search.shop.length === 15) {
              search.shop.pop();
            }
            search.shop.unshift(this.search);
          }
          localStorage.setItem("homeSearchHistory", JSON.stringify(search));
        }
      } else if (this.isStore) {
        if (this.search != "") {
          var supplierindex = search.supplier.indexOf(this.search);
          if (supplierindex > -1) {
            search.supplier.unshift(
              search.supplier.splice(supplierindex, 1)[0]
            );
          } else {
            if (search.supplier.length === 15) {
              search.supplier.pop();
            } else {
              search.supplier.unshift(this.search);
            }
          }
          localStorage.setItem("homeSearchHistory", JSON.stringify(search));
        }
      }
    },
    // 鼠标移入商品分类显示
    onclassover() {
      const path = this.$route.path;
      //   || path == '/store/details'
      if (path == "/Home" || path == "/search/searchPage") {
        this.isnavMenuShow = true;
      } else {
        this.isnavMenuShow = false;
      }
    },
    onclassout() {
      const path = this.$route.path;
      if (path == "/Home") {
        this.isnavMenuShow = true;
      } else {
        this.isnavMenuShow = false;
      }
    },
    //  关键字高亮显示
    htmlValue(val) {
      const key = this.search;
      if (key.length > 0) {
        return val.replace(
          new RegExp(key, "g"),
          "<span style='color: #666;'>" + key + "</span>"
        );
      }
      return val;
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    loadAll() {
      return [
        { value: "电钻配件大全", address: "39" },
        { value: "电钻配件大全", address: "40" },
        { value: "电钻配件大全", address: "113" },
        { value: "电钻配件大全(天山西路店)", address: "43" },
        { value: "电钻配件大全", address: "18" },
        { value: "电钻配件大全", address: "33" },
      ];
    },
    handleSelect(item) {
      //   console.log(item)
      if (typeof item === "object") {
        this.search = item.text;
        this.searchClick();
      }
    },
    // 快速求购页面跳转
    toFastBuy() {
      this.$router.push({ path: "/buy/postBuyLeads" });
    },
    // 点击了购物车按钮
    shopCart() {
      this.$router.push({ path: "/shop/shoppingCart" });
    },
    // 获取首页侧边栏列表数据
    async getStockClass() {
      // const res = await getStockClass()
      const res = await getCatalogSet();
      if (res.result) {
        this.stockClassList = res.rows;
      } else {
      }
    },
  },
};
</script>

<style lang="scss">
.el-header .searchStockIpt {
  .el-autocomplete {
    width: 100%;
  }

  .el-input-group--append .el-input__inner {
    border: 2px solid #ec212d;
  }

  .el-input-group__append {
    border: 1px solid #ec212d;
  }

  .all-history .el-scrollbar {
    position: relative;
    padding-top: 16px;

    .allHisDel {
      position: absolute;
      font-size: 12px;
      right: 16px;
      top: 0;
      display: block;
      background: #fff;
      margin-top: 6px;
    }
  }

  .my-autocomplete {
    width: 567px !important;
    border: 2px solid #ec212d;

    li {
      line-height: normal;
      padding: 11px;
      display: flex;
      justify-content: space-between;

      .name {
        text-overflow: ellipsis;
        overflow: hidden;
        font-size: 14px;
        color: #333;
      }

      .addr {
        font-size: 12px;
        color: #999;
      }

      .search-text {
        color: #ec212d;
      }

      .highlighted .addr {
        color: #ddd;
      }
    }

    .el-icon-loading {
      display: block;
      margin: auto;
    }
  }

  .popper__arrow {
    display: none;
  }
}
</style>
<style lang='scss' scoped>
/* 顶栏容器CSS */
.el-header .searchTab {
  width: 1219px;
  min-width: 1219px;
  height: 93px;
  padding-top: 33px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  background-color: #fff;
}

.el-header .logo {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80px;
  width: 246px;
  float: left;
  margin-right: 60px;
}

.el-header .logo img {
  max-height: 80px;
  max-width: 246px;
}

.el-header .so {
  flex: none;
  width: 550px;
  padding: 0px;
  margin-bottom: 28px;
  margin-right: 60px;
}

.el-header .so .channel {
  display: flex;
  cursor: pointer;

  .shopBtn,
  .storeBtn {
    width: 54px;
    height: 30px;
    border-radius: 2px 2px 0px 0px;
    font-size: 16px;
    color: #333;
    text-align: center;
    line-height: 30px;
    margin-bottom: -2px;
  }

  .active {
    background: #ec212d;
    color: #fff;
  }
}

.el-header .so .searchButton {
  width: 130px;
  height: 38px;
  background: #ec212d;
  box-shadow: 0px 5px 10px 0px rgba(236, 33, 45, 0.3);
  border-radius: 0px 3px 3px 0px;
  font-size: 16px;
  color: #ffffff;
}

.el-header .el-button {
  padding: unset;
}

.el-header .so .el-input__inner {
  height: 38px;
  background: #ffffff;
  border: 2px solid #ec212d;
  border-radius: 4px 0 0 4px;
}

.el-header .so .el-input__inner::-webkit-input-placeholder {
  font-size: 16px;
  font-family: Microsoft YaHei;
  color: #999999;
}

.el-header .rightButton .Box {
  width: 130px;
  height: 38px;
  background: #ffffff;
  border: 1px solid #cdcdcd;
  border-radius: 4px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  color: #ec212d;
}

.el-header .rightButton {
  display: flex;

  .svg-icon {
    width: 19.3px;
    height: 18px;
    margin: auto 0;
    margin-right: 8px;
  }

  .headorgBoxTo {
    width: 160px;
    position: relative;
    height: 40px;
    text-indent: 20px;
    line-height: 40px;
    background: #f5783c;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    color: #fff;
    border: 1px solid #f5783c;
    margin-right: 24px;

    .fizz {
      position: absolute;
      text-align: center;
      text-indent: 0;
      font-size: 12px;
      right: 12px;
      top: 3px;
      width: 26px;
      height: 15px;
      line-height: 15px;
      background: #fff;
      color: #f5783c;
      border-radius: 8px 8px 8px 0px;
      opacity: 0.88;
    }
  }

  .headBoxTo {
    width: 130px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 1px rgba(0, 0, 0, 0.16);
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    color: #ec212d;

    .boxto-con {
      display: flex;
      justify-content: center;

      .box-text {
        margin: auto 0;
      }
    }
  }
}

/* 顶部导航栏CSS */
.navBar {
  width: 1219px;
  min-width: 1219px;
  margin: 0 auto;
  position: relative;
  z-index: 999;
}

.classifyGoods {
  height: 0;
}

.classifyGoods .top {
  width: 246px;
  height: 40px;
  background: #ec2631;
  text-align: left;
  padding-left: 10px;
  line-height: 40px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  color: #ffffff;

  .svg-icon {
    width: 1.5em;
    height: 1.5em;
    vertical-align: -0.35em;
    margin-right: 3px;
  }
}

.nav-menu {
  z-index: 99999;
  // display: none;
  width: 246px;
  height: 482px;
  // background: #323232;
  background: #fff;
  border-top: solid 1px #eee;
  padding: 0px 0;
  padding-top: 10px;
  overflow-y: overlay;

  &::-webkit-scrollbar {
    background: transparent;
    width: 5px;
  }

  &::-webkit-scrollbar-thumb {
    width: 5px;
    background: rgba(236, 33, 45, 0.6);
    border-radius: 3px;
    // overflow-y:auto;
  }

  &::after {
    content: "";
  }

  .menu-wrap {
    .menu-item {
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      // color: #ffffff;
      color: #333333;
      width: 100%;
      // height: 108px;
      padding: 0px 12px;
      height: 46px;

      .goodsName {
        overflow: hidden;
        font-size: 16px;
        float: left;
      }

      .classBox {
        height: 46px;
        display: flex;

        .seleimg {
          float: left;
          width: 20px;
          height: 18px;
          margin: auto 0;
          margin-right: 13px;
          vertical-align: middle;
          object-fit: contain;
        }

        .goodsName {
          font-size: 16px;
          float: left;
          line-height: 46px;
          color: #333333;
          font-family: Microsoft YaHei-Regular, Microsoft YaHei;
          font-weight: 400;
          overflow: hidden;
        }
      }

      .subSpan {
        display: inline-block;
        padding-right: 10px;
        line-height: 20px;
        opacity: 0.8;

        &:last-child {
          padding-right: 0px;
        }

        &:hover {
          color: #ec212d;
        }
      }

      .subclass {
        display: inline-block;
        font-size: 12px;
        margin-top: 10px;

        .subSpan {
          display: inline-block;
          padding-right: 10px;
          line-height: 20px;
          opacity: 0.8;
        }
      }

      &:hover {
        // background-color: #4c4c4c;
        background: #eeeeee;

        .children {
          z-index: 9999;
          display: block;
        }
      }

      .children {
        display: none;
        width: 955px;
        height: 482px;
        background-color: #fff;
        position: absolute;
        top: 0;
        left: 246px;
        padding: 0 20px;
        overflow-x: hidden;
        overflow-y: auto;

        ul {
          li {
            // height: 100px;
            display: flex;
            // justify-content: space-around;
            // align-items: center;
            padding: 15px 0;
            border-bottom: 1px solid #eee;

            .shopType {
              font: bold 14px "Microsoft YaHei", "黑体", sans-serif;
              // flex: 25%;
              width: 138px;
              //   font-size: 12px;
              //   font-family: SimSun;
              font-weight: 600;
              color: #333333;
              margin-left: 6px;
              padding-right: 15px;
              cursor: pointer;
              margin-top: 14px;
              //   margin-right: 20px;
              text-align: right;

              &:hover {
                color: #ec2631;
              }
            }

            .shopKind {
              width: 760px;
              font-size: 14px;
              font-weight: 400;
              color: #333333;

              div {
                padding-top: 14px;
                display: inline-block;
                cursor: pointer;

                &:hover {
                  color: #ec2631;
                }

                &::before {
                  content: "|";
                  width: 1px;
                  height: 12px;
                  color: #737373;
                  margin: 0 3px;
                }
              }
            }
          }
        }
      }
    }
  }
}

.navigation {
  margin-top: 19px;
  height: 0px;
  display: flex;
  align-items: center;

  .liTotal {
    line-height: 16px;

    img {
      float: left;
    }

    .blodText {
      float: left;
    }
  }
}

.navigation li .blodText {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  padding-left: 2px;
}

.navigation li {
  padding: 0 20px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;

  &:first-child {
    padding-left: 0;
  }

  &:last-child {
    padding-right: 0;
  }
}

.navigation li:hover {
  cursor: pointer;
}

.headerBar {
  box-shadow: 0px 2px 4px 0px rgba(50, 50, 50, 0.1);
}

/* 顶部导航栏CSS END */

/* 顶栏容器CSS */
.el-header .searchTab {
  width: 1219px;
  min-width: 1219px;
  height: 93px;
  padding-top: 33px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  background-color: #fff;
}

.el-header .logo {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80px;
  width: 246px;
  float: left;
  margin-right: 60px;
  margin-top: -13px;
}

.el-header .logo img {
  max-height: 80px;
  max-width: 246px;
}

.el-header .so .channel {
  display: flex;
  cursor: pointer;

  .shopBtn,
  .storeBtn {
    caret-color: rgba(0, 0, 0, 0);
    width: 84px;
    height: 30px;
    border-radius: 2px 2px 0px 0px;
    font-size: 16px;
    color: #333;
    text-align: center;
    line-height: 30px;
    margin-bottom: -2px;
  }

  .active {
    background: #ec212d;
    color: #fff;
  }
}

.el-header .so .searchButton {
  width: 130px;
  height: 38px;
  background: #ec212d;
  box-shadow: 0px 5px 10px 0px rgba(236, 33, 45, 0.3);
  border-radius: 0px 3px 3px 0px;
  font-size: 16px;
  color: #ffffff;
}

.el-header .el-button {
  padding: unset;
}

.el-header .so .el-input__inner {
  height: 38px;
  background: #ffffff;
  border: 2px solid #ec212d;
  border-radius: 4px 0 0 4px;
}

.el-header .so .el-input__inner::-webkit-input-placeholder {
  font-size: 16px;
  font-family: Microsoft YaHei;
  color: #999999;
}

.el-header .rightButton .Box {
  width: 130px;
  height: 38px;
  background: #ffffff;
  border: 1px solid #cdcdcd;
  border-radius: 4px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  color: #ec212d;
}
</style>
